<template>
  <UserSingle
    :user="user"
  />
</template>

<script>
import UserSingle from '../../components/UserSingle'

export default {
  name: 'UserSinglePage',

  components: {
    UserSingle
  },

  async beforeRouteLeave (to, from, next) {
    if (this.user && this.user.isChanged) {
      const answer = await this.$root.$confirm(this.$t('Attention'), this.$t('You have unsaved changes. Are you sure want to leave?'), { color: 'primary' })
      if (answer) {
        this.user.reset()
      }
      return next(answer)
    }
    next()
  },

  actionBar () {
    return {
      title: 'User',
      actions: [
        {
          text: 'Back',
          event: 'back',
          disabled: false
        },
        {
          text: 'Save',
          event: 'save',
          disabled: true
        },
        {
          color: 'error',
          text: 'Delete',
          event: 'delete',
          disabled: true
        }
      ]
    }
  },

  data () {
    return {
      user: {}
    }
  },

  computed: {
    isCreate () {
      return this.$route.params.id === '__'
    },

    saveActionStates () {
      return {
        disabled: !this.user || this.user.inProgress || !this.user.isChanged || this.user.errors.length,
        loading: !this.user || this.user.inProgress
      }
    },

    deleteActionStates () {
      return {
        disabled: !this.user || this.user.inProgress || this.isCreate
      }
    }
  },

  async mounted () {
    try {
      this.user = this.isCreate ? this.$http.make('auth:user')
        : await this.$http.make('auth:user').find(this.$route.params.id, { headers: { 'x-user-type': 'admin' } })
      this.user.reset()

      if (this.isCreate) {
        this.user.type = 'admin'
        this.$radio.$emit('action-panel-title', 'New User')
      } else {
        this.$radio.$emit('action-panel-title', this.user.name)
      }
    } catch (e) {
      this.$toast.error(this.$t(e.message))
    }

    this.$radio.$on('requested-user-save', this.onActionSave)
  },

  methods: {
    goBack () {
      this.$router.push({ name: 'users' })
    },

    onActionBack () {
      this.goBack()
    },

    async onActionSave () {
      try {
        if (!this.isCreate && !this.user.password) {
          this.user.without(['password', 'password_confirmation'])
        }

        this.user.role_ids = this.user.roles
          ? this.user.roles.map(item => typeof item === 'object' ? item.id : item) : []
        this.user.permission_ids = this.user.permissions
          ? this.user.permissions.map(item => typeof item === 'object' ? item.id : item) : []

        await this.user.save()

        if (this.isCreate) {
          this.$router.replace({
            name: 'single_user',
            params: { id: this.user.id }
          })
          this.$radio.$emit('action-panel-title', this.user.name)
          this.$toast.success(this.$t('User created'))
          return
        }
        this.$toast.success(this.$t('User updated'))
      } catch (e) {
        this.$vuetify.goTo(0)
        this.$toast.error(this.$t(e.message))
      }
    },

    async onActionDelete () {
      if (!await this.$root.$confirm(this.$t('Delete User'), this.$t('Please Confirm'), { color: 'red' })) {
        return
      }
      await this.user.delete({ headers: { 'x-user-type': 'admin' } })
      this.goBack()
    }
  }
}
</script>
